function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { load } from "@lululemon/mwa-isomorphic-cookie";
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import Cookies from "js-cookie";
import { composeDataMethods, getCatalog, loadCatalog, getSupportedLocale } from "@lululemon/mwa-utils";

/**
 * @deprecated
 * Please do not add lingui to your app
 * We are moving to SWC and lingui is not compatible
 * react-i18next is the current alternative
 * See the following decision doc:
 * https://lululemon.atlassian.net/wiki/spaces/MWAP/pages/2956427907/Lingui+replacement+-+Decision+doc
 */
const withLingui = ({
  getCatalogLoader,
  loadPlurals
}) => Component => {
  console.warn("Your app is wrapped in a withLingui HOC. We are deprecating Lingui in order to support SWC.");
  console.warn("Please see this decision doc https://lululemon.atlassian.net/wiki/spaces/MWAP/pages/2956427907/Lingui+replacement+-+Decision+doc");
  const WithLingui = props => {
    const {
      locale,
      pathName
    } = props;
    const {
      plurals,
      messages
    } = getCatalog(locale.lang, pathName);
    i18n.loadLocaleData(locale.lang, {
      plurals
    });
    i18n.load(locale.lang, messages);
    i18n.activate(locale.lang);
    return /*#__PURE__*/React.createElement(I18nProvider, {
      i18n: i18n
    }, /*#__PURE__*/React.createElement(Component, props));
  };
  composeDataMethods(Component, {
    getInitialProps: async ctx => {
      var _ctx$req, _ctx$req$cookies;
      const locale = (ctx === null || ctx === void 0 ? void 0 : (_ctx$req = ctx.req) === null || _ctx$req === void 0 ? void 0 : (_ctx$req$cookies = _ctx$req.cookies) === null || _ctx$req$cookies === void 0 ? void 0 : _ctx$req$cookies.UsrLocale) || load("UsrLocale", ctx === null || ctx === void 0 ? void 0 : ctx.req, false) || Cookies.get("UsrLocale") || "en_US";
      const lang = getSupportedLocale(locale.replace("_", "-"));
      const localeWithLang = _extends({}, locale, {
        lang
      });
      ctx.locale = localeWithLang;
      await loadCatalog(lang, ctx.pathname, getCatalogLoader, loadPlurals);
      return {
        locale: localeWithLang,
        pathName: ctx.pathname
      };
    }
  })(WithLingui);
  return WithLingui;
};
export default withLingui;